function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { Component } from 'react';
import omit from 'lodash/omit';
import findKey from 'lodash/findKey';
import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';
import classNames from 'classnames';
import gettext from 'js-utils/gettext';
import lazyGettext from 'js-utils/lazy-gettext';
import ValidationFormField from '../validationFormField/ValidationFormField';
import Select from '../select/Select';
import SelectField from '../inputField/SelectField';
import TextInput from '../textInput/TextInput';
import InputField from '../inputField/InputField';
import NotificationBar from '../notification/NotificationBar';
import { TYPE_ERROR } from '../notification/constants';
import * as constants from './constants';
/**
 * Due to redux-form implementation of event callbacks, we need to
 * transform the event arguments to match our contract
 *
 * @param {function} eventHandler handler to call when event is fired
 */

var wrapHandleEvent = function wrapHandleEvent(eventHandler) {
  return function (_event, newValue) {
    if (eventHandler) {
      eventHandler(newValue);
    }
  };
};

var ToplevelError = function ToplevelError(_ref) {
  var error = _ref.error;
  var component = null;

  if (error) {
    component = React.createElement("div", {
      className: "eds-g-cell eds-g-cell-1-1"
    }, React.createElement(NotificationBar, {
      type: TYPE_ERROR,
      hasCloseButton: true
    }, React.createElement("span", null, error)));
  }

  return component;
};

var OptionalLegend = function OptionalLegend(_ref2) {
  var legend = _ref2.legend,
      v2 = _ref2.v2;
  var component = null;
  var componentClasses = classNames('eds-g-cell', 'eds-g-cell-1-1', {
    'eds-l-mar-bot-1': !v2,
    'eds-l-mar-bot-2': v2
  });

  if (legend) {
    component = React.createElement("div", {
      className: componentClasses,
      "data-spec": "optional-address-field-legend"
    }, React.createElement("legend", {
      className: "eds-label-primary eds-text-bl"
    }, legend));
  }

  return component;
};

var AddressFormInputField = function AddressFormInputField(_ref3) {
  var v2 = _ref3.v2,
      shouldDisplayError = _ref3.shouldDisplayError,
      disabled = _ref3.disabled,
      onChange = _ref3.onChange,
      onBlur = _ref3.onBlur,
      inputProps = _objectWithoutProperties(_ref3, ["v2", "shouldDisplayError", "disabled", "onChange", "onBlur"]);

  var flowThroughProps = inputProps;
  var propsWithNoHideLabel = omit(inputProps, 'hideLabel');
  var InputComponent = TextInput;

  if (v2) {
    flowThroughProps = propsWithNoHideLabel;
    InputComponent = InputField;
  }

  return React.createElement(ValidationFormField, _extends({
    v2: v2,
    shouldDisplayError: shouldDisplayError,
    onChange: wrapHandleEvent(onChange),
    onBlur: wrapHandleEvent(onBlur)
  }, flowThroughProps), React.createElement(InputComponent, _extends({}, propsWithNoHideLabel, {
    disabled: disabled
  })));
};

var AddressFormSelectField = function AddressFormSelectField(_ref4) {
  var v2 = _ref4.v2,
      shouldDisplayError = _ref4.shouldDisplayError,
      disabled = _ref4.disabled,
      onChange = _ref4.onChange,
      onBlur = _ref4.onBlur,
      inputProps = _objectWithoutProperties(_ref4, ["v2", "shouldDisplayError", "disabled", "onChange", "onBlur"]);

  var flowThroughProps = inputProps;
  var propsWithNoHideLabel = omit(inputProps, 'hideLabel');
  var SelectComponent = Select;

  if (v2) {
    flowThroughProps = propsWithNoHideLabel;
    SelectComponent = SelectField;
  }

  return React.createElement(ValidationFormField, _extends({
    v2: v2,
    shouldDisplayError: shouldDisplayError,
    onChange: wrapHandleEvent(onChange),
    onBlur: wrapHandleEvent(onBlur)
  }, flowThroughProps), React.createElement(SelectComponent, _extends({}, propsWithNoHideLabel, {
    disabled: disabled
  })));
};

var REGION_COMPONENT_NAMES = {
  'SelectField': function SelectField(values, v2) {
    return values && v2;
  },
  'Select': function Select(values, v2) {
    return values && !v2;
  },
  'InputField': function InputField(values, v2) {
    return !values && v2;
  },
  'TextInput': function TextInput(values, v2) {
    return !values && !v2;
  }
};
var REGION_COMPONENTS = {
  SelectField: SelectField,
  Select: Select,
  InputField: InputField,
  TextInput: TextInput
};

var RegionComponent = function RegionComponent(_ref5) {
  var v2 = _ref5.v2,
      values = _ref5.values,
      label = _ref5.label,
      inputProps = _objectWithoutProperties(_ref5, ["v2", "values", "label"]);

  var props = omit(inputProps, ['hideLabel']);
  var componentName = findKey(REGION_COMPONENT_NAMES, function (value, key) {
    return REGION_COMPONENT_NAMES[key](values, v2);
  });
  var NewRegionComponent = REGION_COMPONENTS[componentName];
  var placeholder = gettext('e.g. California');

  if (values) {
    // Translators: e.g. "Choose State" or "Choose Region"
    placeholder = gettext('Choose %(label)s', {
      label: label
    });
  }

  return React.createElement(NewRegionComponent, _extends({}, props, {
    values: values,
    label: label,
    placeholder: placeholder
  }));
};

var PostalField = function PostalField(_ref6) {
  var label = _ref6.label,
      required = _ref6.required,
      shown = _ref6.shown,
      name = _ref6.name,
      id = _ref6.id,
      onChange = _ref6.onChange,
      onBlur = _ref6.onBlur,
      defaultValue = _ref6.defaultValue,
      value = _ref6.value,
      hideLabel = _ref6.hideLabel,
      inputProps = _objectWithoutProperties(_ref6, ["label", "required", "shown", "name", "id", "onChange", "onBlur", "defaultValue", "value", "hideLabel"]);

  var component = null;

  if (shown) {
    component = React.createElement(AddressFormInputField, _extends({}, inputProps, {
      name: name,
      label: label,
      required: required,
      defaultValue: defaultValue,
      hideLabel: hideLabel,
      id: id,
      "data-spec": "address-postal-field",
      maxLength: constants.MAX_POSTAL_CODE_LENGTH,
      onChange: onChange,
      onBlur: onBlur,
      value: value
    }));
  }

  return component;
};

var BaseAddressFields =
/*#__PURE__*/
function (_Component) {
  _inherits(BaseAddressFields, _Component);

  function BaseAddressFields() {
    _classCallCheck(this, BaseAddressFields);

    return _possibleConstructorReturn(this, _getPrototypeOf(BaseAddressFields).apply(this, arguments));
  }

  _createClass(BaseAddressFields, [{
    key: "_handleChange",
    value: function _handleChange(name, value) {
      if (this.props.onChange) {
        this.props.onChange(value, name);
      }
    }
  }, {
    key: "_handleBlur",
    value: function _handleBlur(name, value) {
      if (this.props.onBlur) {
        this.props.onBlur(value, name);
      }
    }
  }, {
    key: "_handleCountryChange",
    value: function _handleCountryChange(value) {
      this._handleChange('country', value);

      if (this.props.onCountryChange) {
        this.props.onCountryChange(value);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          countryValues = _this$props.countryValues,
          required = _this$props.required,
          disabledFields = _this$props.disabledFields,
          idPrefix = _this$props.idPrefix,
          namePrefix = _this$props.namePrefix,
          error = _this$props.error,
          regionLabel = _this$props.regionLabel,
          regionRequired = _this$props.regionRequired,
          regionValues = _this$props.regionValues,
          postalLabel = _this$props.postalLabel,
          postalRequired = _this$props.postalRequired,
          postalShown = _this$props.postalShown,
          defaultValues = _this$props.defaultValues,
          values = _this$props.values,
          label = _this$props.label,
          hideLabels = _this$props.hideLabels,
          v2 = _this$props.v2,
          shouldDisplayError = _this$props.shouldDisplayError;

      var makeName = function makeName(suffix) {
        return namePrefix + suffix;
      };

      var makeId = function makeId(suffix) {
        return idPrefix + suffix;
      };

      var extraMarginsForV2 = v2 ? {
        'eds-l-mar-top-2': v2
      } : {};
      var formFieldClassNames = classNames('eds-g-cell', 'eds-g-cell-1-1', 'eds-g-cell-mn-1-2', 'eds-l-mn-pad-right-2', 'eds-l-md-pad-right-2', 'eds-l-mw-pad-right-2', 'eds-l-ln-pad-right-2', 'eds-l-lg-pad-right-2', 'eds-l-lw-pad-right-2', extraMarginsForV2);
      var addressClassNames = classNames('eds-g-cell', 'eds-g-cell-1-1', 'eds-g-cell-mn-1-2', 'eds-l-mn-pad-left-2', 'eds-l-md-pad-left-2', 'eds-l-mw-pad-left-2', 'eds-l-ln-pad-left-2', 'eds-l-lg-pad-left-2', 'eds-l-lw-pad-left-2', extraMarginsForV2);
      var regionClassNames = classNames('eds-g-cell', 'eds-g-cell-1-2', 'eds-g-cell-mn-3-12', 'eds-l-mn-pad-right-2', 'eds-l-md-pad-right-2', 'eds-l-mw-pad-right-2', 'eds-l-ln-pad-right-2', 'eds-l-lg-pad-right-2', 'eds-l-lw-pad-right-2', 'eds-l-mn-pad-left-2', 'eds-l-md-pad-left-2', 'eds-l-mw-pad-left-2', 'eds-l-ln-pad-left-2', 'eds-l-lg-pad-left-2', 'eds-l-lw-pad-left-2', extraMarginsForV2);
      var postalClassNames = classNames('eds-g-cell', 'eds-g-cell-1-2', 'eds-g-cell-mn-3-12', 'eds-l-pad-left-2', extraMarginsForV2);
      return React.createElement("div", {
        className: "eds-g-grid eds-base-address-fields"
      }, React.createElement("div", {
        className: "eds-g-group"
      }, React.createElement("fieldset", null, React.createElement(ToplevelError, {
        error: error
      }), React.createElement(OptionalLegend, {
        legend: label,
        v2: v2
      }), React.createElement("div", {
        className: formFieldClassNames,
        "data-spec": "address-one-field-wrapper"
      }, React.createElement(AddressFormInputField, {
        name: makeName('address1'),
        label: gettext('Address 1'),
        placeholder: gettext('e.g. 155 5th Street'),
        required: required,
        disabled: disabledFields.address1,
        hideLabel: hideLabels,
        defaultValue: defaultValues.address1,
        v2: v2,
        id: makeId('address1'),
        onChange: this._handleChange.bind(this, 'address1'),
        onBlur: this._handleBlur.bind(this, 'address1'),
        value: values.address1,
        "data-spec": "address-one-field",
        shouldDisplayError: shouldDisplayError
      })), React.createElement("div", {
        className: addressClassNames
      }, React.createElement(AddressFormInputField, {
        name: makeName('address2'),
        label: gettext('Address 2'),
        hideLabel: hideLabels,
        defaultValue: defaultValues.address2,
        disabled: disabledFields.address2,
        v2: v2,
        id: makeId('address2'),
        onChange: this._handleChange.bind(this, 'address2'),
        onBlur: this._handleBlur.bind(this, 'address2'),
        placeholder: gettext('e.g. Apt, Suite, Bldg'),
        shouldDisplayError: shouldDisplayError
      })), React.createElement("div", {
        className: formFieldClassNames
      }, React.createElement(AddressFormInputField, {
        name: makeName('city'),
        label: gettext('City'),
        hideLabel: hideLabels,
        placeholder: gettext('e.g. San Francisco'),
        required: required,
        disabled: disabledFields.city,
        defaultValue: defaultValues.city,
        v2: v2,
        id: makeId('city'),
        onChange: this._handleChange.bind(this, 'city'),
        onBlur: this._handleBlur.bind(this, 'city'),
        value: values.city,
        shouldDisplayError: shouldDisplayError
      })), React.createElement("div", {
        className: regionClassNames
      }, React.createElement(ValidationFormField, {
        name: makeName('region'),
        label: regionLabel,
        hideLabel: hideLabels,
        required: required && regionRequired,
        values: regionValues,
        v2: v2,
        shouldDisplayError: shouldDisplayError
      }, React.createElement(RegionComponent, {
        id: makeId('region'),
        "data-spec": "address-region-field",
        values: regionValues,
        onChange: this._handleChange.bind(this, 'region'),
        onBlur: this._handleBlur.bind(this, 'region'),
        value: values.region,
        disabled: disabledFields.region,
        label: regionLabel,
        v2: v2
      }))), React.createElement("div", {
        className: postalClassNames
      }, React.createElement(PostalField, {
        shown: postalShown,
        name: makeName('postal'),
        label: postalLabel,
        hideLabel: hideLabels,
        placeholder: gettext('e.g. 94103'),
        required: required && postalRequired,
        disabled: disabledFields.postal,
        id: makeId('postal'),
        onChange: this._handleChange.bind(this, 'postal'),
        onBlur: this._handleBlur.bind(this, 'postal'),
        defaultValue: defaultValues.postal,
        value: values.postal,
        v2: v2,
        shouldDisplayError: shouldDisplayError
      })), React.createElement("div", {
        className: formFieldClassNames
      }, React.createElement(AddressFormSelectField, {
        name: makeName('country'),
        label: gettext('Country'),
        hideLabel: hideLabels,
        placeholder: gettext('Choose a country'),
        required: required,
        disabled: disabledFields.country,
        values: countryValues,
        id: makeId('country'),
        onChange: this._handleCountryChange.bind(this),
        onBlur: this._handleBlur.bind(this, 'country'),
        "data-spec": "address-country-field",
        value: values.country,
        v2: v2,
        shouldDisplayError: shouldDisplayError
      })))));
    }
  }]);

  return BaseAddressFields;
}(Component);

_defineProperty(BaseAddressFields, "propTypes", {
  /**
  * An array of objects with country display names and values
  * ex. [{value: 'england', display: 'England'}, {value: 'usa', display: 'United States of America'}]
  **/
  countryValues: constants.COUNTRY_VALUES_PROP.isRequired,

  /**
  * An object with address fields to be set as default
  * ex. {address1: '123 Fifth St.', address2: 'Unit 1', city: 'San Francisco', region: 'CA', postal: '94103', country: 'United States'}
  **/
  defaultValues: constants.ADDRESS_VALUES_PROP,

  /**
   * An object with address fields to be disabled
   * ex. {country: true}
   */
  disabledFields: constants.DISABLED_FIELDS_PROP,

  /**
  * Error message
  * ex. 'The address you entered is invalid'
  **/
  error: PropTypes.node,

  /**
  * Optional prefix in front of ids
  **/
  idPrefix: PropTypes.string,

  /**
  * Optional prefix in front of name values
  **/
  namePrefix: PropTypes.string,

  /**
  * A callback triggered when the value of input changes, passing in the value and name of the field changes
  * ex. (value, name) => { console.log(value, name) // 'California', 'region' }
  **/
  onChange: PropTypes.func,

  /**
  * A callback triggered when the input is blurred.
  **/
  onBlur: PropTypes.func,

  /**
  * A callback triggered when the value of the country changes
  * ex. (value) => {}
  **/
  onCountryChange: PropTypes.func,

  /**
  * Label for postal code, ex. 'Zip Code'
  **/
  postalLabel: EBPropTypes.translation,

  /**
  * Whether or not the postal code is required
  **/
  postalRequired: PropTypes.bool,

  /**
  * Whether or not the postal code should be shown
  **/
  postalShown: PropTypes.bool,

  /**
  * Label for region, ex. 'State'
  **/
  regionLabel: EBPropTypes.translation,

  /**
  * Whether or not the region is required
  **/
  regionRequired: PropTypes.bool,

  /**
  * An array of objects with values and display pertaining to a region
  * ex. [{value: ca, display:California}, {value:quebec, dispaly:Quebec}]
  * If regionValues is not supplied, region will render as a TextInput
  **/
  regionValues: constants.REGION_VALUES_PROP,

  /**
  * Whether or not the address is required, adds a * next to the fields if true
  **/
  required: PropTypes.bool,

  /**
  * An object with address fields that overrides defaultValues with fixed values
  * ex. {address1: '123 Fifth St.', address2: 'Unit 1', city: 'San Francisco', region: 'CA', postal: '94103', country: 'United States'}
  **/
  values: constants.ADDRESS_VALUES_PROP,

  /**
   * Text to render label-like above the fields
   */
  label: PropTypes.node,

  /**
   * Hides label above the fields
   */
  hideLabels: PropTypes.bool,

  /**
   * Determines whether it should use or not a FormField wrapper.
   */
  v2: PropTypes.bool,

  /**
   * Function to determine whether we should
   * display an error given the input state. Has a sensible default.
   */
  shouldDisplayError: PropTypes.func
});

_defineProperty(BaseAddressFields, "defaultProps", {
  idPrefix: '',
  namePrefix: '',
  required: false,
  defaultValues: {},
  disabledFields: {},
  values: {},
  regionLabel: lazyGettext('State'),
  regionRequired: true,
  postalLabel: lazyGettext('Postal Code'),
  postalRequired: true,
  postalShown: true
});

export { BaseAddressFields as default };